import * as React from 'react'

const EntityTabBar = (props: { children: any }) => {
  if (!props.children) {
    return null
  }

  return <div className='col-12 flex px2 bb-grey4 border-box tab-selector'>{props.children}</div>
}

export default EntityTabBar



// WEBPACK FOOTER //
// ./src/components/ui/entity/EntityTabBar.tsx